// 产品列表
const productList = {
  tabList: [
    { cate_name: "全部" },
  ]
}


// 产品详情
const productDetail = {
  label1: '规格型号',
  label2: '综合信息',
  label3: '性能特点',
  label4: '产品优势',
  label5: '结构特点',
  label6: '样本下载',
  label7: '关联执行器',
  label8: '关联改型阀',
  label9: '可与下列执行器组合使用：',
  label10: '关联下列改型阀门：',
}

const onlineMessage = {
  info_list: [
    {
      label: "产品经理人：",
      content: "杜经理"
    },
    {
      label: "联系邮件：",
      content: "info@kelkflow.com.cn"
    },
    {
      label: "联系电话：",
      content: "+86-(0)510-85141699"
    },
    /* {
      label: "",
      content: `
        <div style="color: #00335a;margin-top:-10px;">
          (工作时间：周一至周五，上午8:00 - 下午4:30)
        </div>
      `
    }, */
  ],
  qrcode: [
    { label: '企业微信', src: require("@/assets/images/callMe/qrIcon.png"), }
  ]
}


export default {
  title: '产品中心',
  subTitle: 'KELK 产品中心',
  text1: '套筒导向型单座调节阀',
  searchTitle: '查询到与 “$keywords” 相关的 $count 项产品',
  searchPlaceholder: '请输入产品名称或型号',
  searchListTitle: '产品搜索',
  searchTip: '提示：请输入产品名称或型号',
  // 产品列表
  productList,
  // 产品详情
  productDetail,
  onlineMessage,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/productCenterPage.js